
import { 
  Rocket, Sparkles, Share2, Users, UserPlus, BarChart3, UsersRound, DollarSign,
  Milestone, Award, Zap, TrendingUp, Trophy, Coins, Medal, Crown
} from "lucide-react";

// Map icons to achievement IDs
export const achievementIcons = {
  joined: <Rocket className="h-6 w-6" />,
  created_form: <Sparkles className="h-6 w-6" />,
  embed_form: <Share2 className="h-6 w-6" />,
  first_visitor: <Users className="h-6 w-6" />,
  first_lead: <UserPlus className="h-6 w-6" />,
  "100_views": <BarChart3 className="h-6 w-6" />,
  "25_leads": <UsersRound className="h-6 w-6" />,
  "10k_interest": <DollarSign className="h-6 w-6" />,
  // New achievement icons
  "50_leads": <Milestone className="h-6 w-6" />,
  "25k_interest": <Award className="h-6 w-6" />,
  "100_leads": <Zap className="h-6 w-6" />,
  "50k_interest": <TrendingUp className="h-6 w-6" />,
  "200_leads": <Trophy className="h-6 w-6" />,
  "100k_interest": <Coins className="h-6 w-6" />,
  "500_leads": <Medal className="h-6 w-6" />,
  "500k_interest": <Crown className="h-6 w-6" />,
};
